import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Verificar directamente en sessionStorage primero (más confiable)
  // Esto asegura que funcione incluso si el estado de React no se ha actualizado
  // sessionStorage se limpia automáticamente al cerrar el navegador
  const hasToken = authService.isAuthenticated();
  const isAuth = hasToken || isAuthenticated;

  // Solo mostrar loading en la carga inicial cuando realmente no hay token
  if (loading && !hasToken) {
    return (
      <div className="content">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    );
  }

  // Si hay token en sessionStorage, permitir acceso (incluso si el estado de React no está actualizado)
  // sessionStorage se limpia automáticamente al cerrar el navegador
  if (hasToken) {
    return children;
  }

  // Si no hay token, redirigir a login
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;

